import { Route } from "@angular/router";
import { CommandeListComponent } from "./commande-list.component";

export const CommandeListRouting: Route = {
  path: "list",
  component: CommandeListComponent,
  data: {
    breadcrumb: "Liste"
  }
};
